import React, { Component } from 'react'
import propTypes from 'prop-types'
import { withRouter } from 'react-router'
import { extendObservable, toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Formik, Form, Field } from 'formik'
import Button from '@components/Button'
import FormError from '@components/FormError/FormError'
import RichTextEditor from '@components/Form/RichTextEditor'
import yup from 'yup'

import ContractualDetailsStore from './contractual-details.store'

class ContractualDetailsPage extends Component {
  static propTypes = {
    growlStore: propTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      contractualDetailsStore: new ContractualDetailsStore()
    })

    this.contractualDetailsStore.get()
  }

  state = { error: null }

  save = data => {
    const { update } = this.contractualDetailsStore

    return update(data)
  }

  handleSubmit = (values, actions) => {
    const { growlStore } = this.props

    this.save(values)
      .then(() => this.contractualDetailsStore.get())
      .then(() => growlStore.showSuccess('Contractual details saved'))
      .catch(({ message }) => {
        growlStore.showError(message)
        actions.setSubmitting(false)
        this.setState({ error: message })
      })
  }

  render () {
    const { loading, contractualDetails } = this.contractualDetailsStore

    if (loading) {
      return null
    }

    return (
      <div className='contractual-details-form-wrapper'>
        <Formik
          initialValues={toJS(contractualDetails)}
          onSubmit={this.handleSubmit}
          validationSchema={() =>
            yup.object().shape({
              value: yup.string().required('The value cannot be empty')
            })
          }
          render={form => (
            <div className='expert-form'>
              <h1 className='expert-form__title'>
                Contract standard conditions
              </h1>
              <FormError error={this.state.error} />
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                  <Field
                    name='value'
                    label=''
                    skipWrapper
                    component={RichTextEditor}
                  />
                </div>
                <div className='expert-form__section'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

export default withRouter(
  inject('growlStore')(observer(ContractualDetailsPage))
)
